/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

const currentYear = new Date().getFullYear();

export const COPYRIGHT = `© ${currentYear} Recreation.gov. All rights reserved.`;
